import { parsePhoneNumberFromString } from 'libphonenumber-js';

/** Mostly a utility function to the implementation of parsePhone,
 * but returns the libphonenumber-js PhoneNumber to use directly.
 * This is used in modifiers.js to preserve an old formatPhone()
 * behavior.
 */
export function parseToPhoneNumberObject(input) {
  if (typeof input !== 'string') {
    return null;
  }
  const prefixedPhoneString = input.startsWith('+') ? input : `+${input}`;

  return parsePhoneNumberFromString(prefixedPhoneString);
}

export default function parsePhone(input) {
  const phoneNumber = parseToPhoneNumberObject(input);
  if (phoneNumber) {
    return {
      countryCode: phoneNumber.countryCallingCode,
      nationalFormat: phoneNumber.formatNational(),
      e164: phoneNumber.format('E.164'),
    };
  }

  // input is either a string that didn't parse, or wasn't a string at all.
  const placeholder = typeof input === 'string' ? input : '';
  return {
    countryCode: '1',
    nationalFormat: placeholder,
    e164: placeholder,
  };
}
